import { useTranslation } from "react-i18next";


/** City Hall special shop banner — presentation only. */
export default function FurnitureShopMayorBanner() {
  const { t } = useTranslation();

  return (
    <div className="mx-xl mt-lg mb-xs flex items-start gap-[10px] rounded-md border border-solid border-reward-alpha-35 bg-[linear-gradient(135deg,var(--color-reward-alpha-12)_0%,var(--color-reward-warm-alpha-8)_100%)] px-[14px] py-lg">
      <span className="mt-px shrink-0 text-[22px] leading-[1]">🏛️</span>
      <div>
        <div className="mb-xs [font-family:Lato,sans-serif] text-[13px] font-bold text-gold">
          {t("Mayor's Special Shop")}
        </div>
        <div className="[font-family:Lato,sans-serif] text-[12px] leading-[1.45] text-white-alpha-75">
          {t("This shop is exclusively available to the current mayor of the island. The furniture purchased here decorates the City Hall and remains there, passing to every future mayor.")}
        </div>
      </div>
    </div>
  );
}
